/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../Common/DataTableFilter";
import { ClearFormSetFutios, getOfferSchemesList } from "../../redux/actions/adminActions";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../Common/CommonTable";
import {
  ADD_OFFER_SCHEME_URL,
  EDIT_OFFER_SCHEME_URL,
} from "../Shared/constant";
import { useNavigate } from "react-router-dom";
import GetOfferSchemeListAPI from "../../Api/GetOfferSchemeListAPI";
import { toast } from "react-toastify";

const OfferCampaigns = () => {
  const Dispatch = useDispatch();
  const Navigate = useNavigate();
  const {OfferSchemesListing, selfInfo, accessToken } =
    useSelector((state) => state.adminReducers);
  const [userType, setUserType] = useState("all");
  const [userLimit, setUserLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const PermissionsAccess = selfInfo?.user?.permissions_access;

  // page change
  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  // select user type
  const SelectUserTypeFnct = (e) => {
    setUserType(e.target.value);
    setCurrentPage(1);
  };

  // api calling
  const APICall = async () => {
    if (
      selfInfo?.user?.user_type === "super_admin" ||
      PermissionsAccess?.DealerApp[7]?.Edit ||
      PermissionsAccess?.DealerApp[7]?.View
    ) {
      const params = {
        status:
          userType === "active" ? true : userType === "inactive" ? false : "",
        limit: userLimit,
        page_no: currentPage,
        order_by: "-updated_at",
      };
      try {
        let response = await GetOfferSchemeListAPI(params, accessToken);
        Dispatch(getOfferSchemesList(response.data));

        if (response.status !== 200) {
          toast.error(response.message);
        } else {
        Dispatch(getOfferSchemesList(response.data));
        }
      } catch (error) {
        toast.error("Error Fetching Offer & Schemes:", error.message);
      }
    }
  };

  // when page load api calling
  useEffect(() => {
    APICall();
  }, [userType, currentPage, userLimit]);

  // create applications
  const cmnFnct = () => {
    Navigate(ADD_OFFER_SCHEME_URL);
  };

  useEffect(() => {
    Dispatch(
      ClearFormSetFutios({
        url: "",
        action: false,
      }),
    );
  }, []);
  // TABLE COLUMNS ARRAY
  const TableColumns = [
    {
      key: "card_title",
      label: "Card Title",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "card_description",
      label: "Card Description",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "start_date",
      label: "Start Date",
      type: "date",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "end_date",
      label: "End Date",
      type: "date",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "status",
      label: "Status",
      type: "status_active",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "categories",
      label: "categories",
      type: "categories_tables",
      sort: "",
      isCollapsable: true,
    },
  ];

  return (
    <section className="Main_section">
      {/* DATA TABLE FILTER */}
      <DataTableFilter
        filterType={"MarketCampaigns"}
        searchType={""}
        userType={userType}
        setUserType={setUserType}
        userLimit={userLimit}
        setUserLimit={setUserLimit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        SelectUserTypeFnct={SelectUserTypeFnct}
        buttonvisible={
          selfInfo?.user?.user_type === "super_admin" ||
          PermissionsAccess?.DealerApp[7]?.Edit
        }
        ButtonSet={{
          buttontitle: "Create Offer & Scheme",
          function: cmnFnct,
        }}
        searchdisable={false}
        ActiveInactiveFilter={true}
      />
      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(OfferSchemesListing?.pagination?.total_records) ===
            OfferSchemesListing?.list?.length
              ? "calc(100vh - 140px)"
              : parseInt(OfferSchemesListing?.pagination?.total_records) > 10
                ? "calc(100vh - 175px)"
                : "calc(100vh - 140px)",
        }}
        srNumber={{
          clickable: false,
          events: "",
        }}
        isCollapsable={false}
        tabName={""} // TAB URL
        PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={OfferSchemesListing} // CATEGORY LIST
        Pagination={OfferSchemesListing?.pagination} // CURRENT TAB PAGINATION
        EditAccess={
          selfInfo?.user?.user_type === "super_admin" ||
          PermissionsAccess?.DealerApp[7]?.Edit
        } // EDITABLE ACCESS STATE
        isActionColumnAvailable={{
          isShow:
            selfInfo?.user?.user_type === "super_admin" ||
            PermissionsAccess?.DealerApp[7]?.Edit,
          label: "edit_offer_scheme",
          naviagte: `${EDIT_OFFER_SCHEME_URL}`,
        }}
        isActionTwoColumnAvailable={{
          isShow: false,
          url: "",
        }}
        isOdiFilterRowColorsAllow={false}
      />
    </section>
  );
};

export default OfferCampaigns;
